import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DataService {
  private messageSource = new BehaviorSubject('');
  private paymentFormState: Record<string, unknown> | null = null;
  currentMessage = this.messageSource.asObservable();
  public successValue = new BehaviorSubject<string>('');
  successValueChange = this.successValue.asObservable();



  constructor() { }

  changeSuccessMessage(message: string) {
    this.successValue.next(message)
  }

  changeMessage(message: string) {
    localStorage.setItem('search-mashpoa', message);
    this.messageSource.next(message)
  }

  setPaymentFormState(state: Record<string, unknown>): void {
    this.paymentFormState = { ...state };
  }

  consumePaymentFormState(): Record<string, unknown> | null {
    const state = this.paymentFormState;
    this.paymentFormState = null;
    return state ? { ...state } : null;
  }

  clearPaymentFormState(): void {
    this.paymentFormState = null;
  }
}
